// @flow

import * as React from 'react'

import * as appLinks from '@toggl/app-links'

import template from './onClickLinkScript'
import type { DataLayer } from './types'

export { useUTM, stringifyUTM } from './useUTM'

declare var window: { dataLayer: DataLayer }

type Props = {
  gtmId: string,
}

// Google Tag Manager `BODY` component.
export const Body = ({ gtmId }: Props): React.Element<'noscript'> => (
  <noscript>
    <iframe
      src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
    />
  </noscript>
)

// Google Tag Manager `HEAD` component.
export const Head = ({ gtmId }: Props) => {
  return (
    <React.Fragment>
      <script dangerouslySetInnerHTML={{ __html: headSrc(gtmId) }} />
    </React.Fragment>
  )
}

// Google Tag Manager `BODY` raw source.
export const body = (gtmId: string) => {
  if (!gtmId) return ''
  // TODO: Prepack and minify. https://github.com/toggl/public-web/issues/925
  const handlerSrcript = template
  return `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><script>${handlerSrcript}</script>`
}

// Google Tag Manager `HEAD` raw source.
export const head = (gtmId: string) =>
  gtmId ? `<script>${headSrc(gtmId)}</script>` : ''

const headSrc = (
  gtmId
) => `var dataLayer = [];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`

const deskopAppLinks = [
  appLinks.APP_MACOS,
  appLinks.APP_WINDOWS,
  appLinks.APP_WINDOWS64,
  appLinks.APP_LINUX,
]

export const onClickLink = (e: MouseEvent) => {
  if (e.target instanceof Element) {
    const anchor = e.target.closest('a')

    if (anchor instanceof HTMLAnchorElement) {
      const href = anchor.href

      if (href.includes(appLinks.EXTENSION_CHROME)) {
        window.dataLayer?.push({
          event: 'browser_extension.clickthrough',
          type: 'chrome',
        })
      }

      if (href.includes(appLinks.EXTENSION_FIREFOX)) {
        window.dataLayer?.push({
          event: 'browser_extension.clickthrough',
          type: 'firefox',
        })
      }

      if (href.includes(appLinks.APP_IOS)) {
        window.dataLayer?.push({
          event: 'mobile_app.clickthrough',
          type: 'iOS',
        })
      }

      if (href.includes(appLinks.APP_ANDROID)) {
        window.dataLayer?.push({
          event: 'mobile_app.clickthrough',
          type: 'Android',
        })
      }

      if (deskopAppLinks.some((url) => href.includes(url))) {
        window.dataLayer?.push({
          event: 'desktop_app.clickthrough',
        })
      }
    }
  }
}

export const onClickLinkSrc = template
